"use client";

import { Booklet } from "~/components/icons/16/Booklet";
import { useIssuuModal } from "~/components/ui/Issuu/lib/useIssuuModal";
import { textconfig } from "~/textconfig";

export const OpenPreviewButton = () => {
	const { open } = useIssuuModal();
	return (
		<button onClick={open} type="button" className="transparent small">
			<Booklet />
			<span>{textconfig.pdp.booklets.previewBtn}</span>
		</button>
	);
};
